import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["modal", "form", "sessionTitle", "nameInput"];
  static values = {
    baseUrl: String
  };

  connect() {
    this.handleModalHidden = this.handleModalHidden.bind(this);

    if (this.hasModalTarget) {
      this.modalTarget.addEventListener("hidden.bs.modal", this.handleModalHidden);
    }
  }

  disconnect() {
    if (this.hasModalTarget) {
      this.modalTarget.removeEventListener("hidden.bs.modal", this.handleModalHidden);
    }
  }

  open(event) {
    event.preventDefault();

    const { sessionId, sessionTitle } = event.currentTarget.dataset;

    this.formTarget.action = this.baseUrlValue.replace(":id", sessionId);
    this.sessionTitleTarget.textContent = sessionTitle;
    this.nameInputTarget.value = `${sessionTitle} (Copy)`;

    Modal.getOrCreateInstance(this.modalTarget).show();

    this.modalTarget.addEventListener("shown.bs.modal", () => {
      this.nameInputTarget.focus();
      this.nameInputTarget.select();
    }, { once: true });
  }

  handleModalHidden() {
    this.nameInputTarget.value = "";
  }
}
